import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuthStore } from './store/auth'
import Landing from './pages/Landing'
import Jobs from './pages/Jobs'
import JobResults from './pages/JobResults'
import Calendar from './pages/Calendar'
import Volunteer from './pages/Volunteer'
import Settings from './pages/Settings'
import SkillMd from './pages/SkillMd'

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated } = useAuthStore()

  if (!isAuthenticated) {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}

export default function App() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/jobs" element={
          <ProtectedRoute>
            <Jobs />
          </ProtectedRoute>
        } />
        <Route path="/jobs/:jobId" element={
          <ProtectedRoute>
            <JobResults />
          </ProtectedRoute>
        } />
        <Route path="/calendar" element={
          <ProtectedRoute>
            <Calendar />
          </ProtectedRoute>
        } />
        <Route path="/settings" element={
          <ProtectedRoute>
            <Settings />
          </ProtectedRoute>
        } />
        <Route path="/skill" element={
          <ProtectedRoute>
            <SkillMd />
          </ProtectedRoute>
        } />
        <Route path="/volunteer/:scheduledId" element={<Volunteer />} />
      </Routes>
    </div>
  )
}
